import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { apiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Layers, Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      login(data.token, data.user);
      navigate("/");
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex">
      <div className="w-full md:w-[440px] bg-[#18181B] flex flex-col justify-center px-10 text-white">
        <div className="flex items-center gap-2 mb-10">
          <Layers className="text-amber-500" size={28} />
          <div>
            <div className="font-head font-black text-2xl tracking-tight leading-none">BY BONE ÜRETİM TAKİP</div>
            <div className="mt-1.5 text-lg font-head font-black italic tracking-[0.2em] bg-gradient-to-r from-amber-400 via-yellow-300 to-orange-500 bg-clip-text text-transparent drop-shadow-[0_1px_3px_rgba(251,191,36,0.4)]">MUSTAFA TASARIM</div>
          </div>
        </div>
        <h2 className="font-head font-bold text-xl mb-1">Giriş Yap</h2>
        <p className="text-sm text-zinc-400 mb-6">Devam etmek için hesabınıza giriş yapın.</p>
        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <div>
            <label className="block text-xs font-semibold text-zinc-400 mb-1 uppercase tracking-wide">E-posta</label>
            <input
              data-testid="login-email"
              type="email" value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-zinc-800 border border-zinc-700 rounded-sm px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-amber-600"
              placeholder="ornek@firma.com" required
            />
          </div>
          <div>
            <label className="block text-xs font-semibold text-zinc-400 mb-1 uppercase tracking-wide">Şifre</label>
            <input
              data-testid="login-password"
              type="password" value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-zinc-800 border border-zinc-700 rounded-sm px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-amber-600"
              placeholder="••••••••" required
            />
          </div>
          {error && <div className="text-sm text-red-400 bg-red-950/40 border border-red-900 rounded-sm px-3 py-2" data-testid="login-error">{error}</div>}
          <button
            type="submit" disabled={loading} data-testid="login-submit"
            className="w-full bg-amber-600 hover:bg-amber-700 text-white font-semibold py-2.5 rounded-sm transition-colors flex items-center justify-center gap-2 disabled:opacity-60"
          >
            {loading && <Loader2 className="animate-spin" size={16} />} Giriş Yap
          </button>
        </form>
      </div>
      <div className="hidden md:block flex-1 relative">
        <img
          src="https://images.unsplash.com/photo-1676451727332-790e79f6cc59?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
          alt="Fabrika" className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/40" />
        <div className="absolute bottom-10 left-10 text-white">
          <div className="font-head font-black text-3xl tracking-tight">Üretim & Sipariş Takibi</div>
          <div className="text-zinc-300 mt-1">Şekillendirme • Bisküvi • Kalite • Stok • Sipariş</div>
        </div>
      </div>
    </div>
  );
}
